import React from 'react';
import T from 'prop-types';

import SimpleCheckbox from '../../../Checkbox/SimpleCheckbox';

const EmailNotification = ({ active, onChange, disabled = false }) => (
  <section className="export-settings-section">
    <div className="export-settings-section__about">
      <h4 className="h5 export-settings-section__title">Notifications</h4>
    </div>
    <div className="export-settings-section__content">
      <div className="export-settings-section__options">
        <SimpleCheckbox
          id="email-notification-option"
          label="Email export when ready"
          checked={active}
          disabled={disabled}
          gap="12px"
          size="lg"
          className="checkbox-text-14 text-black"
          onChange={onChange}
        />
      </div>
    </div>
  </section>
);

EmailNotification.propTypes = {
  active: T.bool.isRequired,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

export default EmailNotification;
